import React, { useEffect, useState, useMemo } from 'react';
import { Modal, ModalHeader, ModalBody, Input, FormGroup, Button, Label, Form, Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';
import moment from 'moment';
import './feedback.css';
import Table from './common/Table';
const common = require('../utils/Common');

const ClientTable = () => {
  const navigate = useNavigate();
  const [sellerData, setSellerData] = useState([]);
  const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));
  const [totalRecords, setTotalRecords] = useState(0);
  const [userRights, setUserRights] = useState({view: false, edit: false, delete: false, create: false});
  const [page, setPage] = useState(1);

  useEffect(() => {
    checkAccess();
  }, []);

  const checkAccess = async () => {
    let rights = await common.checkAccessRights(window.location.pathname);
    if (!rights.view) {
      alert("Access Denied");
      navigate("/");
      return;
    } else {
      setUserRights(rights);
      getSellerDetails();
    }
  };

  const getSellerDetails = async (limit = 10, offset = 0, search = {}, loader = true, reset = false) => {
    if (reset) {
        setPage(1);
        offset = 0;
    } else {
        setPage(offset / limit + 1);
    }
    const currentStartDate = $('#Date-from').val() || startDate;
    const currentEndDate = $('#Date-to').val() || endDate;
    
    setStartDate(currentStartDate);
    setEndDate(currentEndDate);
    
    const parameters = {
      'Start_Date': currentStartDate,
      'End_Date': currentEndDate,
      'limit': limit,
      'offset': offset
    };
    
    let response = await common.apiRequest('post', '/admin/seller-product-service-approve', parameters, loader);
    let data = (response.data && response.data.data) ? response.data.data : [];
    
    setSellerData(data);
    setTotalRecords(response.data.totalRecords);
  };

  const movePage = (path, seller_id,rowType) => {
    console.log(
      path,
      seller_id,
      rowType,
      startDate,
      endDate
    )
    navigate(path, {
      state: {
        sellerId: seller_id, 
        rowType: rowType,
        startDate: startDate,
        endDate: endDate
      }
    });
  };

  const handleDateChange = (e) => {
    if (e.target.id === "Date-from") {
      setStartDate(e.target.value);
    } else if (e.target.id === "Date-to") {
      setEndDate(e.target.value);
    }
    getSellerDetails();
  };

  return (
    <>
      <div className="col-md-12">
        <div>
          <h4 className="card-title mb-0">Client Table</h4>
        </div>
        <Form className='row'>
          <FormGroup className='col-md-4 row'>
            <Label className="col-md-2 col-form-label" for="Date-from">From:</Label>
            <input 
              type='date' 
              value={startDate}
              onChange={handleDateChange}
              className="form-control col-md-5" 
              id="Date-from" 
              name="Date-from"
            />
          </FormGroup>
          <FormGroup className='col-md-4 row'>
            <Label className=" col-md-2 col-form-label" for="Date-to">To:</Label>
            <input 
              type='date' 
              value={endDate}
              onChange={handleDateChange}
              className="form-control col-md-5" 
              id="Date-to" 
              name="Date-to"
            />
          </FormGroup>
        </Form>
      </div>
      <div className='ag-theme-alpine' style={{ 
  minHeight: 300, 
  maxHeight: 800, 
  height: 'auto',
  width: '100%' 
}}>        <Table 
          columns={[
            {
              header: "User Id",
              accessor: "reg_id",
            },
            {
              header: "First Name",
              accessor: "first_name",
            },
            {
              header: "Middle Name",
              accessor: "middle_name",
            },
            {
              header: "Last Name",
              accessor: "last_name",
            },
            {
              header: "Type",
              accessor: "vendorResponse",
            },
            {
              header: "Not Approved",
              accessor: "notApproved",
            },
            {
              header: "Created At",
              accessor: "created_at",
              render: (row) => {
                let date = '';
                switch (row.rowType) {
                  case 'logistics':
                    date = row.logistics_service_created_at;
                    break;
                  case 'service':
                    date = row.service_created_at;
                    break;
                  case 'product':
                    date = row.product_created_at;
                    break;
                  default:
                    break;
                }
                return date ? date.split('T')[0] : '';
              },
            },
            {
              header: "Action",
              accessor: "adminResponseDate",
              render: (row) => (
                // userRights.edit ??
                <button 
                  className="btn btn-primary btn-sm"
                  onClick={() => {
                    const targetUrl = row.rowType === 'product'
                      ? '/sellers-products'
                      : '/seller-service-approve';
                    movePage(targetUrl, row.seller_id, row.rowType);
                  }}
                >
                  View Details
                </button>
              ),
            }
          ]}
          data={sellerData}
          totalRecords={totalRecords}
          pageSize={10}
          currentPage={page}
          onPageChange = {(limit, offset, search, reset) =>{
              getSellerDetails(limit, offset, search, true, reset);
          }}
        />
      </div>
    </>
  );
};

export default ClientTable;